import { SHBox } from "@components/design-systems";
import { generateUUID } from "@utils";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const DEFAULT_PLACEMENT_ID = generateUUID();

export interface AnalysisToolBarPlacementProps {
  id?: string;
}
export interface AnalysisToolBarContainerProps {
  id?: string;
  placementId?: string;
  children?: React.ReactNode;
}

export const AnalysisToolBarPlacement = ({
  id = DEFAULT_PLACEMENT_ID,
}: AnalysisToolBarPlacementProps) => (
  <SHBox sx={{ width: "100%", height: "100%" }} id={id} />
);

export const AnalysisToolBarContainer = ({
  id = "analysis-tool-bar-container",
  placementId = DEFAULT_PLACEMENT_ID,
  children,
}: AnalysisToolBarContainerProps) => {
  const [placement, setPlacement] = useState(
    document.getElementById(placementId),
  );

  useEffect(() => {
    setPlacement(document.getElementById(placementId));
  }, [placementId]);

  if (!placement) return null;
  return createPortal(
    <SHBox sx={{ width: "100%", height: "100%" }} id={id}>
      {children}
    </SHBox>,
    placement,
  );
};
